module.exports = __webpack_public_path__ + "static/media/icon-search.8d5ef721.svg";